<template lang="html" src="./CompaniesInApproval.html">

</template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      companies: [],
      selected: [],
      partner:null,
      popUpCompany: false,
      titlePopUp: "",
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      search: "",
      totalCompanies: 0
    };
  },
  mounted() {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function () {
      this.getCompaniesInApproval();
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getCompaniesInApproval();
    },
    handleSelected(tr) {
      const vm = this;
      vm.selected = tr;
      console.log(vm.selected);
      vm.titlePopUp = vm.selected.name;

      if (vm.selected.name) {
        vm.selected.name = vm.selected.name;
      } else {
        vm.selected.name = "";
      }
      if(vm.selected.phone){
        vm.selected.phone = vm.selected.phone;
      }
      else {
        vm.selected.phone = "Sem registro";
      }
      if(vm.selected.partnerId){
        vm.selected.partner = vm.selected.partnerId.name;
      }
      else {
        vm.selected.partner = "Sem registro";
      }
      if (vm.selected.companyName) {
        vm.selected.companyName = vm.selected.companyName;
      } else {
        vm.selected.companyName = "Sem registro";
      }
      if (vm.selected.cnpj !== null) {
        vm.selected.cpnjMask = vm.maskCnpj(vm.selected.cnpj);
      } else {
        vm.selected.cpnjMask = "Sem registro";
      }
      if (vm.testNullUndefinedEmpty(vm.selected.email)) {
        vm.selected.email = "Sem registro";
      } else {
        vm.selected.email = vm.selected.email;
      }
      if (vm.selected.legalRepresentative) {
        vm.selected.legalRepresentative = vm.selected.legalRepresentative;
      } else {
        vm.selected.legalRepresentative = "Sem registro";
      }
      if (vm.selected.address) {
        if (vm.testNullUndefinedEmpty(vm.selected.address.street)) {
          vm.selected.street = "Sem registro";
        } else {
          vm.selected.street = vm.selected.address.street;
        }
        if (vm.testNullUndefinedEmpty(vm.selected.address.complement)) {
          vm.selected.complement = "Sem registro";
        } else {
          vm.selected.complement = vm.selected.address.complement;
        }
        if (vm.testNullUndefinedEmpty(vm.selected.address.city)) {
          vm.selected.city = "Sem registro";
        } else {
          vm.selected.city = vm.selected.address.city;
        }
        if (vm.testNullUndefinedEmpty(vm.selected.address.state)) {
          vm.selected.state = "Sem registro";
        } else {
          vm.selected.state = vm.selected.address.state;
        }
        if (vm.testNullUndefinedEmpty(vm.selected.address.zipcode)) {
          vm.selected.zipcode = "Sem registro";
        } else {
          vm.selected.zipcode =
            vm.selected.address.zipcode.substring(0, 5) +
            "-" +
            vm.selected.address.zipcode.substring(5, 10);
        }
      }

      vm.popUpCompany = true;
    },
    approveCompany() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/companies/" +
            vm.selected.id +
            "/approve"
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.popUpCompany = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Operação realizada com sucesso. A empresa aprovada será notificada",
              icon: "success"
            }).then(function() {
              vm.getCompaniesInApproval();
            });
          }
        })
        .catch(function() {
          vm.popUpCompany = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação.Por favor contacte o administrador do sistema.",
            icon: "error"
          });
        });
    },
    disapproveCompany() {
      const vm = this;
      const disaprove = {
        message: "Empresa não aprovada"
      }
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "admin/companies/" +
            vm.selected.id +
            "/disapprove", disaprove
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.popUpCompany = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Operação realizada com sucesso. A empresa recusada será notificada",
              icon: "success"
            }).then(function() {
              vm.getCompaniesInApproval();
            });
          }
        })
        .catch(function() {
          vm.popUpCompany = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação.Por favor contacte o administrador do sistema.",
            icon: "error"
          });
        });
    },
    getCompaniesInApproval() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            `admin/new-companies?search=${vm.search}&page=${vm.currentx - 1}&size=10&sort=id,desc`,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
            vm.totalCompanies = response.data.totalElements;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.fillCompanies();
          }
        });
    },
    fillCompanies() {
      const vm = this;
      for (let c in vm.companies) {
        if (vm.companies[c].countEmployees > 0) {
          vm.companies[c].employees =
            vm.companies[c].countEmployees + " funcionário(s)";
        } else {
          vm.companies[c].employees = "Nenhum registro";
        }
        if (vm.companies[c].status == "WAITING_APPROVE") {
          vm.companies[c].statusBr = "Pendente";
        } else {
          vm.companies[c].statusBr = "Reprovada";
        }
        if (vm.testNullUndefinedEmpty(vm.companies[c].name)) {
          vm.companies[c].name = "Sem registro";
        }
      }
    },
    changePagination(){
      const vm = this;
      vm.getCompaniesInApproval();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    handleSearch(search) {
      this.search = search
      this.currentx = 1
      this.getCompaniesInApproval();
    }
  }
};
</script>
<style src="./CompaniesInApproval.css">
</style>